module.exports = __webpack_public_path__ + "img/jerryyoon.50581803.jpg";